module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_6.2c32820f.png";